<template><div class="container-login101">


    <div class="limiter ">
      <!-- The video -->



      <div class="container-login100">

        <div class="wrap-login100">


          <form
            class="login100-form validate-form"
            @submit.prevent="onSubmit"
            autocomplete="off"
          >
            <span class="login100-form-title p-b-34 p-t-27">
              <img src="/img/logo_abtool_bianco.svg" width="200" />
            </span>


            <p
              class="text-center"
              v-if="errorMsg === '' && stepLogin === 1"
              style="
                padding: 3px;
                color: red;
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                border-radius: 10px;
              "
            >
              <i
                class="fas fa-sync-alt fa-spin"
                style="color: white; font-size: 200%"
              ></i>
            </p>
            <p
              v-if="errorMsg === '' && stepLogin === 0"
              class="small text-center"
              style="padding: 3px; color: white"
            >
              {{ $t("login.utilizza") }}

              <span v-if="language === 'it'">
                formazione.alfiobardolla.com</span
              >
              <span v-else>formacion.alfiobardolla.es</span>
            </p>

            <p
              class="text-center small"
              v-if="errorMsg !== '' && stepLogin === 0"
              style="
                background-color: white;
                padding: 3px;
                color: red;
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                border-radius: 10px;
              "
            >
              {{ errorMsg }}
            </p>

            <div
              class="wrap-input100 validate-input"
              data-validate="Enter username"
              style="border-bottom: none"
            >
              <label style="color: white">
                {{ $t("login.username") }}
                <input
                  class="input100"
                  type="email"
                  name="email"
                  style="border: 1px solid #fefefe"
                  placeholder=""
                  v-model="email"
                />
              </label>
            </div>
            <div
              class="wrap-input100 validate-input"
              data-validate="Enter password"
              style="border-bottom: none"
            >
              <label style="color: white">
                {{ $t("login.password") }}
                <input
                  class="input100"
                  style="border: 1px solid #fefefe"
                  type="password"
                  name="password"
                  placeholder=""
                  v-model="password"
                />
              </label>
            </div>
            <div class="alert alert-warning" v-if="msg">{{ msg }}</div>
            <div class="contact100-form-checkbox abtg__login-remember">
              <input
                class="input-checkbox100"
                id="ckb1"
                type="checkbox"
                name="remember-me"
                value="1"
                v-model="condition"
              />
              <label class="label-checkbox100" for="ckb1">
                {{ $t("login.letto") }}
                <a
                  href="https://www.alfiobardolla.com/condizioni-e-pagamento/"
                  style="color: white; text-decoration: underline"
                  target="_blank"
                  >{{ $t("login.condizioni") }}</a
                >
              </label>
            </div>
            <div class="abtg__login-resetpassword text-right">
              <a :href="whichUrl()" target="_blank">{{
                $t("login.dimenticato")
              }}</a>
            </div>

            <div class="container-login100-form-btn">
              <button class="login100-form-btn">
                {{ $t("login.login") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { mixin } from "@/helpers/helper";

import { mapActions, mapState } from "vuex";

export default {
  mixins: [mixin],

  data: function () {
    return {
      email: "",
      password: "",
      condition: 0,
      msg: null,
      language: localStorage.getItem("language")
        ? localStorage.getItem("language")
        : "it",
    };
  },

  computed: {
    ...mapState("n_user", ["errorMsg", "stepLogin"]),
  },
  created: function () {
    this.isRemembered();
    this.checkStats();
  },
  methods: {
    whichUrl() {
      return this.language === "it"
        ? "https://formazione.alfiobardolla.com/wp-login.php?action=lostpassword"
        : "https://formacion.alfiobardolla.es/wp-login.php?action=lostpassword";
    },
    ...mapActions("n_user", ["checkLogin", "isRemembered", "checkStats"]),

    onSubmit: function () {
      if (this.condition === 0) {
        this.msg = "Devi accettare le condizioni contrattuali";
      } else {
        this.checkLogin({ email: this.email, password: this.password });
      }
    },
  },
};
</script>
